import { icon } from './lib/common'

// .m-text p.chiffre-cle
const chiffres = document.querySelectorAll('.m-text p.chiffre-cle')
if (chiffres.length > 0) {
  for (const el of chiffres) {
    let str = el.textContent
    str = str.replace(/(\s+)/g, '<br>')
    str = str.replace(/(\d+)/g, '<span>$1</span>')
    el.innerHTML = str
  }
}

// .m-text p.telephone
const telephones = document.querySelectorAll('.m-text p.telephone')
if (telephones.length > 0) {
  for (const el of telephones) {
    const svg = icon('telephone')
    el.innerHTML = svg + el.innerHTML
  }
}

// .m-text p.email
const emails = document.querySelectorAll('.m-text p.email')
if (emails.length > 0) {
  for (const el of emails) {
    const svg = icon('mail')
    el.innerHTML = svg + el.innerHTML
  }
}

// .n-text-media h2
const h2s = document.querySelectorAll('.n-text-media h2')
if (h2s.length > 0) {
  for (const el of h2s) {
    el.innerHTML = '<span>' + el.innerHTML + '</span>'
  }
}

// .p-contact .n-text-media .text
const texts = document.querySelectorAll('.p-contact .n-text-media .text')
if (texts.length > 0) {
  for (const el of texts) {
    const svg = icon('logo')
    el.innerHTML = svg + el.innerHTML
  }
}
